import React, { useEffect, useRef, useState } from 'react';
import widgetRegistry from './widgetRegistry';

export function useInView(rootMargin = '200px 0px', rootSelector = '.widget-drawer__body') {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        const root = el.closest(rootSelector);
        const observer = new IntersectionObserver(
            (entries) => setInView(Boolean(entries[0]?.isIntersecting)),
            { root, rootMargin, threshold: 0 },
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [rootMargin, rootSelector]);

    return [ref, inView];
}

const WidgetMiniPreview = ({ config }) => {
    const WidgetComponent = widgetRegistry[config.type]?.component;
    if (!WidgetComponent) return null;
    return (
        <div className="widget-tile__stage">
            <WidgetComponent config={config} />
        </div>
    );
};

export default WidgetMiniPreview;
